import { useMutation, useQueryClient } from "@tanstack/react-query";
import { myAccountApi } from "@/features/my-account/api";
import { UserInfoUpdateRequest } from "@/features/my-account/types";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

const useUpdateUserInfo = (userId?: number) => {
  const queryClient = useQueryClient();
  const { error: showError, warning } = useAppToasts();

  const { mutate: mutateUserInfo } = useMutation({
    mutationKey: ["updateUserInfo", userId],
    mutationFn: (userInfo: UserInfoUpdateRequest) =>
      myAccountApi.updateUserInfo(userInfo, userId),
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ["my-account", "user", userId],
      });
    },
    onError: (error) => {
      showError(error);
    },
  });

  return {
    mutateUserInfo,
  };
};

export default useUpdateUserInfo;
